import type { SkeletonShapeProps } from '../types';

import { CircleStyles } from './Circle.styles';

export function Circle(props: SkeletonShapeProps) {
	const { className = '', size, loading = false } = props;
	const styles = CircleStyles({ loading, size, class: className });

	return <div className={styles} />;
}
